import axiosInstance from "../axiosInstance";

export const catalogProductService = {
  fetchByCatalog: async (catalogId) => {
    try {
      const response = await axiosInstance.get(
        `/catalog-product?catalog=${catalogId}&$populate[0][path]=product&$populate[0][select][0]=name&$populate[0][select][1]=variants&$limit=500&$sort[page]=1`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await axiosInstance.post("/catalog-product", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  removeAllByCatalog: async (catalogId) => {
    try {
      const response = await axiosInstance.delete(
        `/catalog-product?catalog=${catalogId}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
